import type { EventBookableItem } from '../FriendsUpcomingParticipations.types'

const getEventBookableItemLink = (publicEventSessionParticipation: EventBookableItem) => {
  return `/activity/${publicEventSessionParticipation.id}`
}

export default getEventBookableItemLink
